/**
 * ============================================================================
 * XPOZER MAGAZINE — Blog Blocks JS
 * ============================================================================
 * Handles: reading progress bar, table of contents generation,
 * reading time calculation, exit-intent popup, sticky mobile CTA,
 * and sticky promo bar behavior.
 */

(function () {
  'use strict';

  /* ========== READING TIME ========== */
  function calcReadingTime() {
    var content = document.getElementById('blogContent');
    var display = document.getElementById('readingTimeValue');
    if (!content || !display) return;
    var text = content.textContent || content.innerText || '';
    var words = text.trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(words / 200));
    display.textContent = minutes;
  }

  /* ========== PROGRESS BAR ========== */
  function initProgressBar() {
    var fill = document.getElementById('blogProgressFill');
    var article = document.getElementById('blogArticle');
    if (!fill || !article) return;

    function update() {
      var rect = article.getBoundingClientRect();
      var articleTop = rect.top + window.pageYOffset;
      var articleHeight = rect.height;
      var scrolled = window.pageYOffset - articleTop;
      var progress = Math.min(100, Math.max(0, (scrolled / (articleHeight - window.innerHeight)) * 100));
      fill.style.width = progress + '%';
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ========== TABLE OF CONTENTS ========== */
  function initTOC() {
    var nav = document.getElementById('blogTocNav');
    var content = document.getElementById('blogContent');
    if (!nav || !content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length === 0) {
      var toc = document.getElementById('blogToc');
      if (toc) toc.style.display = 'none';
      return;
    }

    var html = '';
    headings.forEach(function (h, i) {
      var id = 'section-' + i;
      h.setAttribute('id', id);
      html += '<a href="#' + id + '" class="blog-toc__link" data-index="' + i + '">' + h.textContent + '</a>';
    });
    nav.innerHTML = html;

    /* Active state on scroll */
    var links = nav.querySelectorAll('.blog-toc__link');
    var headingPositions = [];

    function cachePositions() {
      headingPositions = [];
      headings.forEach(function (h) {
        headingPositions.push(h.getBoundingClientRect().top + window.pageYOffset - 120);
      });
    }

    function highlightActive() {
      var scrollPos = window.pageYOffset;
      var activeIndex = 0;
      for (var i = headingPositions.length - 1; i >= 0; i--) {
        if (scrollPos >= headingPositions[i]) {
          activeIndex = i;
          break;
        }
      }
      links.forEach(function (link, j) {
        link.classList.toggle('blog-toc__link--active', j === activeIndex);
      });
    }

    /* Smooth scroll on click */
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(link.getAttribute('href').substring(1));
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    cachePositions();
    window.addEventListener('scroll', highlightActive, { passive: true });
    window.addEventListener('resize', function () {
      cachePositions();
      highlightActive();
    });
    highlightActive();
  }

  /* ========== STICKY PROMO BAR ========== */
  function initStickyBar() {
    var bar = document.getElementById('blogStickyBar');
    if (!bar) return;

    var lastScroll = 0;
    var threshold = 300; /* Show after scrolling past hero */

    function update() {
      var scrollPos = window.pageYOffset;
      if (scrollPos > threshold) {
        bar.classList.add('blog-sticky-bar--visible');
      } else {
        bar.classList.remove('blog-sticky-bar--visible');
      }
      lastScroll = scrollPos;
    }

    window.addEventListener('scroll', update, { passive: true });
  }

  /* ========== STICKY MOBILE CTA ========== */
  function initMobileCTA() {
    var cta = document.getElementById('blogMobileCta');
    if (!cta) return;

    var lastScroll = 0;
    var triggerPercent = 0.3;

    function update() {
      var scrollPos = window.pageYOffset;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrollPercent = scrollPos / docHeight;
      var scrollingUp = scrollPos < lastScroll;

      if (scrollPercent > triggerPercent && !scrollingUp) {
        cta.classList.add('blog-mobile-cta--visible');
      } else if (scrollingUp && scrollPos < lastScroll - 50) {
        cta.classList.remove('blog-mobile-cta--visible');
      }

      /* Always hide near top */
      if (scrollPercent < 0.1) {
        cta.classList.remove('blog-mobile-cta--visible');
      }

      lastScroll = scrollPos;
    }

    window.addEventListener('scroll', update, { passive: true });
  }

  /* ========== EXIT-INTENT POPUP ========== */
  function initExitPopup() {
    var popup = document.getElementById('blogExitPopup');
    var overlay = document.getElementById('blogExitOverlay');
    var closeBtn = document.getElementById('blogExitClose');
    if (!popup) return;

    /* Only on desktop (no hover on touch) */
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

    var shown = false;
    var sessionKey = 'xpz_exit_popup_shown';

    /* Check if already shown this session */
    try {
      if (sessionStorage.getItem(sessionKey)) return;
    } catch (e) { /* sessionStorage unavailable */ }

    /* Minimum time on page before exit popup can trigger */
    var minTime = 30000; /* 30 seconds */
    var pageLoadTime = Date.now();

    function showPopup() {
      if (shown) return;
      if (Date.now() - pageLoadTime < minTime) return;
      shown = true;
      popup.classList.add('blog-exit-popup--visible');
      document.body.style.overflow = 'hidden';
      try {
        sessionStorage.setItem(sessionKey, '1');
      } catch (e) { /* ignore */ }
    }

    function hidePopup() {
      popup.classList.remove('blog-exit-popup--visible');
      document.body.style.overflow = '';
    }

    /* Exit intent: mouse leaves viewport from top */
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && e.relatedTarget == null) {
        showPopup();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', hidePopup);
    if (overlay) overlay.addEventListener('click', hidePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePopup();
    });
  }

  /* ========== FORM HANDLING ========== */
  function initForms() {
    /* Add article handle as hidden field for tracking */
    var forms = document.querySelectorAll('#blogInsiderForm, #blogExitForm');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        /* Optional: add GA4 event tracking */
        if (typeof gtag === 'function') {
          gtag('event', 'blog_signup', {
            event_category: 'engagement',
            event_label: form.id,
            page_location: window.location.href
          });
        }
      });
    });
  }

  /* ========== GA4 SCROLL DEPTH TRACKING ========== */
  function initScrollTracking() {
    if (typeof gtag !== 'function') return;

    var thresholds = [25, 50, 75, 100];
    var fired = {};

    function check() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var percent = Math.round((window.pageYOffset / docHeight) * 100);

      thresholds.forEach(function (t) {
        if (percent >= t && !fired[t]) {
          fired[t] = true;
          gtag('event', 'blog_scroll_depth', {
            event_category: 'engagement',
            event_label: t + '%',
            value: t,
            page_location: window.location.href
          });
        }
      });
    }

    window.addEventListener('scroll', check, { passive: true });
  }

  /* ========== INIT ========== */
  function init() {
    calcReadingTime();
    initProgressBar();
    initTOC();
    initStickyBar();
    initMobileCTA();
    initExitPopup();
    initForms();
    initScrollTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
